import { __assign } from "tslib";
// DS: C115
import React, { useEffect } from 'react';
import { useDismissableNotification } from '../Notifications/Notification/useDismissableNotification';
import LiveNotificationCard from './_partials/LiveNotificationCard';
import { useBiLogger } from '../biLogger/hooks/useBiLogger';
import BiLink from '../biLogger/Components/BiLink';
import BiSpan from '../biLogger/Components/BiSpan';
import { BiEventType } from '../biLogger';
var LiveNotification = function (_a) {
    var id = _a.id, queueName = _a.queueName, notificationHtml = _a.notificationHtml, linkTo = _a.linkTo, biData = _a.biData;
    var logBiEvent = useBiLogger();
    var _b = useDismissableNotification({
        id: id,
        queueName: queueName,
        duration: 10000,
    }), onClose = _b.onClose, onPause = _b.onPause, onUnpause = _b.onUnpause;
    useEffect(function () {
        logBiEvent(__assign({ evid: BiEventType.LIVE_NOTIFICATION_VIEW }, biData));
    }, [logBiEvent, biData]);
    return (React.createElement(LiveNotificationCard, { onClose: onClose, onMouseEnter: onPause, onMouseLeave: onUnpause, biData: biData }, linkTo ? (React.createElement(BiLink, { href: linkTo, dangerouslySetInnerHTML: { __html: notificationHtml }, biData: __assign({ evid: BiEventType.ITEM_CLICK }, biData) })) : (React.createElement(BiSpan, { dangerouslySetInnerHTML: { __html: notificationHtml }, biData: __assign({ evid: BiEventType.ITEM_CLICK }, biData) }))));
};
LiveNotification.displayName = 'LiveNotification';
export default LiveNotification;
//# sourceMappingURL=LiveNotification.js.map